import { useEffect, useRef } from "react";
import axios from "axios";
import { forceLogoutDuplicate } from "../services/authService";
import { stopGlobalAudio } from "../utils/audioManager";

const HEARTBEAT_INTERVAL = 30000;

export const useHeartbeat = () => {
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const baseUrl = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        const sendHeartbeat = async () => {
            const tokenStr = localStorage.getItem("authToken");
            if (!tokenStr) return;

            const { access_token, token_type } = JSON.parse(tokenStr);
            const token = `${token_type} ${access_token}`;

            try {
                const response = await axios.get(`${baseUrl}api/heartbeat`, {
                    headers: {
                        Authorization: token,
                    },
                    validateStatus: () => true,
                });
                if (response.data?.msg_code === 401 && response.data?.msg === "Logged in from another browser") {
                    forceLogoutDuplicate("Logged in from another browser !!");
                     stopGlobalAudio();
                }else if(response.data?.msg_code === 401 && response.data?.msg === "Session expired, please login again"){
                    forceLogoutDuplicate("Session expired, please login again !!");
                     stopGlobalAudio();
                }
            } catch (err) {
                console.error("Heartbeat failed:", err);
            }
        };

        sendHeartbeat();
        intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, []);
};
